export enum HostedScriptsRolloutState {
	InProgress = "InProgress",
	Completed = "Completed",
	Failed = "Failed"
}
